module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/4_2a345c923502b81d6ccc97c85730d301.png";